export default {
  title: 'Hjælp og FAQ',
  buttons: {
    faqs: 'FAQ',
    contact_us: 'Kontakt os',
  },
};
